import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import MultipleSelectCheckmarks from "components/common/dropdowns/MultiSelect";
import SearchAppBar from "components/common/searchBar";
import { useContext } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { minSearchStrLength } from "utils/CommonConstants";
import {
  functionalAreaIdsToNames,
  functionalAreaNamesToIds,
  getBrandOrRegion,
  getCodesByNames,
  getNamesByCodes
} from "utils/CommonFunctions";
import { setFilters } from "../PlanAssignment.slice";

export default function Filters(props: any) {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);

  const functionalAreas = useAppSelector((state: any) => state.functionalAreas?.list);
  const filters: any = useAppSelector((state) => state.PlanAssignment.planSelection.filters);
  const propertyList = useAppSelector((state) => state.PlanAssignment.propertyList);
  const onMultiSelectChange = (value: any) => {
    const areaDetails = functionalAreaNamesToIds(value);
    dispatch(setFilters({ functionalAreas: areaDetails }));
  };

  const getInputDetails = (input: any) => {
    if (input.length > minSearchStrLength || !input) {
      dispatch(setFilters({ searchText: input }));
    }
  };

  const brandAndRegionMultiselectChange = (input: any, type: string) => {
    const res = getCodesByNames(input, type, propertyList);
    dispatch(setFilters({ [type]: res }));
  };

  return (
    <div className="plan_selection-actions">
      <SearchAppBar
        isPreDefinedNav
        value={filters.searchText}
        getInputDetails={getInputDetails}
        sx={{
          border: `1px solid  ${tokens.Border.General.Tertiary}`,
          marginTop: "8px",
          height: "44px",
          width: isMobileScreen ? "none" : "350px"
        }}
      />
      <div className="plan_selection-filters">
        <Typography color={tokens.Text.General.Secondary}>Filter by</Typography>
        {!props?.shouldHideTargetingFilters && (
          <>
            <MultipleSelectCheckmarks
              name="Brand"
              label="Brand"
              minWidth={isMobileScreen ? "100%" : "146px"}
              options={getBrandOrRegion("brand", propertyList)}
              initialValues={getNamesByCodes(filters?.brand, propertyList)}
              onChange={(value: any) => brandAndRegionMultiselectChange(value, "brand")}
            ></MultipleSelectCheckmarks>
            <MultipleSelectCheckmarks
              name="Region"
              label="Region"
              minWidth={isMobileScreen ? "100%" : "146px"}
              options={getBrandOrRegion("region", propertyList)}
              initialValues={filters?.region}
              onChange={(value: any) => brandAndRegionMultiselectChange(value, "region")}
            ></MultipleSelectCheckmarks>
          </>
        )}
        <MultipleSelectCheckmarks
          name="Functional Area"
          label="Functional Area"
          minWidth={isMobileScreen ? "100%" : "146px"}
          options={functionalAreas}
          initialValues={functionalAreaIdsToNames(filters.functionalAreas)}
          onChange={(value: any) => onMultiSelectChange(value)}
        ></MultipleSelectCheckmarks>
      </div>
    </div>
  );
}
